import { ROUTES_CONFIG } from './config/routesConfig';
import { transformRoutes } from './helpers';

/** Routes objects */
export const ROUTES = transformRoutes(ROUTES_CONFIG).root;
